import { createAction, props } from '@ngrx/store';
import { IContractsState } from './contracts.state';

export enum ContractsActions {
  ContractsRequested = '[Contracts] Contracts Requested',
  ContractsLoaded = '[Contracts] Contracts Loaded',
  ContractsError = '[Contracts] Contracts Error'
}

export const ContractsRequested = createAction(ContractsActions.ContractsRequested, props<{userId: string}>());

export const ContractsLoaded = createAction(ContractsActions.ContractsLoaded, props<IContractsState>());

export const ContractsError = createAction(ContractsActions.ContractsError);